export default __webpack_public_path__ + "static/media/google_play.cf903dd4.svg";